export default __webpack_public_path__ + "static/media/030-whale.4295cdd7.svg";